import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><rect transform="rotate(45 1078.282 -1254.14)" x="1212.132" y="385.632" width="4" height="19" rx="2" fill="#000" fillRule="evenodd" /></svg>;